export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/11a14d9b63ec892bb84cea8c67204259.svg";